export const ORIGIN_META = {
  PDF: { label: "PDF vettoriale", cls: "bg-ok-100 text-ok-800 border-ok-300" },
  PDF_ASSISTED: { label: "PDF vettoriale · con correzioni", cls: "bg-tech-100 text-tech-800 border-tech-300" },
  MIXED: { label: "Mista · PDF + utente", cls: "bg-tech-100 text-tech-800 border-tech-300" },
  USER: { label: "Inserimento utente", cls: "bg-warn-100 text-warn-800 border-warn-300" },
  NONE: { label: "Non estratta", cls: "bg-risk-100 text-risk-800 border-risk-300" },
};

export const STATUS_META = {
  OK: { label: "Tempo calcolato", cls: "bg-ok-100 text-ok-800 border-ok-300" },
  MANUAL: { label: "Tempo manuale", cls: "bg-tech-100 text-tech-800 border-tech-300" },
  TODO: { label: "Da completare", cls: "bg-warn-100 text-warn-800 border-warn-300" },
  EXTRACT_ERROR: { label: "Errore di estrazione", cls: "bg-risk-100 text-risk-800 border-risk-300" },
};

const EXTRACT_FAILURES = ["FLAT_VIEW_NOT_FOUND", "SCALE_UNVERIFIED", "SCALE_CONFLICT"];

export const originOf = (pc) => {
  const src = pc?.geometry_source || {};
  const pdf = src.external === "PDF_VECTOR" || src.internal === "PDF_VECTOR";
  const owner = src.external === "OWNER_PROVIDED" || (pc?.owner_inputs_used || []).length > 0;
  if (pdf && owner) return "MIXED";
  if (pdf) return pc?.geometry_overrides ? "PDF_ASSISTED" : "PDF";
  if (owner) return "USER";
  return "NONE";
};

export const statusOf = (pc, geo, cg) => {
  if (pc?.outcome === "AUTOMATIC" || pc?.outcome === "ASSISTED") return "OK";
  if (pc?.outcome === "MANUAL") return "MANUAL";
  const st = geo?.status || "";
  if ((cg?.missing || []).some((m) => m.code === "OUTER_ENVELOPE_MISMATCH")) return "EXTRACT_ERROR";
  return EXTRACT_FAILURES.some((k) => st.startsWith(k)) ? "EXTRACT_ERROR" : "TODO";
};

export const FIX_LABEL = {
  select_page: "seleziona la pagina dello sviluppo",
  select_view: "seleziona la vista dello sviluppo",
  provide_scale: "calibra la scala su una quota",
  decide_text_mode: "decidi la lavorazione della scritta",
  cam_or_owner_input: "inserisci lunghezza CAM / tempo manuale",
};

export const actionsOf = (pc, geo, required, cg) => {
  const out = [];
  const add = (x) => { if (x && !out.includes(x)) out.push(x); };
  (geo?.problems || []).forEach((p) => (p.fix_options || []).forEach((o) => add(FIX_LABEL[o] || o)));
  (cg?.missing || []).forEach((m) => (m.fix_options || []).forEach((o) => add(FIX_LABEL[o] || o)));
  (required || []).forEach((r) => add(r.label));
  if (pc?.outcome === "MANUAL") add("approvazione Owner dell'override");
  return out;
};

export const KIND_LABEL = { CIRCLE: "foro", SLOT: "asola", RECT: "rettangolo", OTHER: "altra apertura" };
export const loopDims = (l) => {
  if (l.kind === "CIRCLE" && l.diameter_mm != null) return `Ø${Number(l.diameter_mm).toFixed(1)}`;
  if (l.shape_length_mm != null && l.shape_width_mm != null) return `${Number(l.shape_length_mm).toFixed(1)}×${Number(l.shape_width_mm).toFixed(1)}${l.rotation_deg ? ` @${Number(l.rotation_deg).toFixed(0)}°` : ""}`;
  if (l.bbox_mm) return `${Number(l.bbox_mm[0]).toFixed(1)}×${Number(l.bbox_mm[1]).toFixed(1)} (ingombro)`;
  return "";
};
